module.exports = __webpack_public_path__ + "static/Gusto-bc9075cdcd421c0932046bc0b2a14737.jpg";